import styled, { keyframes } from 'styled-components'

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

const TickerWrapper = styled.div`
  overflow: hidden;
  padding: 20px 0;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-bg-elevated);
`

const TickerTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${scroll} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`

const TickerItem = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
  white-space: nowrap;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 24px;

  &::after {
    content: '·';
    color: var(--color-accent);
    font-size: 1.4rem;
  }
`

const ITEMS = [
  'Coaching Agents',
  'Support Agents',
  'Lead Qualification',
  'Real Estate Agents',
  'Social Content',
  'Voice AI',
  'Community',
  'Custom Agents',
  'Multilingual',
  'Analytics',
]

export default function ScrollingTicker() {
  const doubled = [...ITEMS, ...ITEMS]

  return (
    <TickerWrapper>
      <TickerTrack>
        {doubled.map((item, i) => (
          <TickerItem key={i}>{item}</TickerItem>
        ))}
      </TickerTrack>
    </TickerWrapper>
  )
}
